import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, FreeMode } from "swiper/modules";
import "swiper/css";
import "./slider.css";
import img1 from "../assets/images/events/img1.JPG";
import img2 from "../assets/images/events/img2.JPG";
import img3 from "../assets/images/events/img3.JPG";
import img4 from "../assets/images/events/img4.JPG";
import img5 from "../assets/images/events/img5.JPG";
import img6 from "../assets/images/events/img6.JPG";
import img7 from "../assets/images/events/img7.JPG";
import img8 from "../assets/images/events/img8.JPG";
import img9 from "../assets/images/events/img9.JPG";
import img10 from "../assets/images/events/img10.JPG";
import img11 from "../assets/images/events/img11.JPG";
import img12 from "../assets/images/events/img12.JPG";
import img13 from "../assets/images/events/img13.JPG";
import img14 from "../assets/images/events/img14.JPG";
import img15 from "../assets/images/events/img15.JPG";

import { Box, Typography } from "@mui/material";

// const imagesRight = [img1, img2, img3, img4, img5, img6, img7];

// const imagesLeft = [img8, img9, img10, img11, img12, img13, img14];

const images = [
  img1,
  img2,
  img3,
  img4,
  img5,
  img6,
  img7,
  img8,
  img9,
  img10,
  img11,
  img12,
  img13,
  img14,
  img15,
];

export default function DualMarqueeSlider2() {
  return (
    <Box
      sx={{
        maxWidth: { xs: "100%", sm: "1440px" },
        margin: "0 auto",
        marginTop: "2rem",
        display: "flex",
        flexDirection: { xs: "column", sm: "column" },
        padding: { xs: "0rem 1.8rem", sm: "0rem 3rem" },
        // backgroundColor: "#ecebeb",
      }}
    >
      <Box
        sx={{
          width: { xs: "100%", sm: "50%" },
        }}
      >
        {/* <Box
          sx={{
            width: "4rem",
            marginTop: { xs: "3rem", sm: "2rem" },
          }}
        >
          <img src={Orangelogo} alt="" width="100%" />
        </Box> */}
        {/* <Typography
          sx={{
            fontFamily: "Montserrat",
            fontSize: { xs: "0.8rem", sm: "1rem" },
            marginTop: "0.4rem",
            fontWeight: "400",
          }}
        >
          MEMORIES{" "}
        </Typography> */}
        <Typography
          variant="h4"
          sx={{
            fontFamily: "Montserrat",
            fontSize: { xs: "1.4rem", sm: "1.6rem" },
            fontWeight: "500",
            marginTop: "1.2rem",
          }}
        >
          Event{" "}
          <span style={{ color: "rgba(255, 102, 0, 1)" }}>Highlights</span>
        </Typography>
      </Box>

      <Box
        sx={{
          width: "100%",
        }}
      ></Box>

      <div style={{ width: "100%", overflow: "hidden" }}>
        <Box sx={{ margin: "2rem" }}></Box>
        {/* Bottom Row - Continuous Left (reverse direction using CSS) */}
        <Swiper
          modules={[Autoplay]}
          className="my-swiper"
          spaceBetween={20}
          loop={true}
          allowTouchMove={false}
          speed={6000}
          slidesPerView={"auto"}
          autoplay={{
            delay: 0,
            disableOnInteraction: false,
            reverseDirection: true, // Reverse scroll
          }}
          breakpoints={{
            320: { slidesPerView: 2 },
            640: { slidesPerView: 3 },
            1024: { slidesPerView: 2 },
          }}
        >
          {images.concat(images).map((src, i) => (
            <SwiperSlide key={i} style={{ width: "250px" }}>
              <img
                src={src}
                alt=""
                style={{
                  width: "100%",
                  height: "350px",
                  objectFit: "cover",
                  borderRadius: "10px",
                }}
              />
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </Box>
  );
}
